export default "__VITE_ASSET__CM2M4DxL__"